import PropertyLoadMoreContainer from "../../../components/property/other/PropertyLoadMore";

const PropertyLoadMore = () => {
  return <PropertyLoadMoreContainer />;
};

export default PropertyLoadMore;
